import { columnSort } from '@repo/zod-schemas'
import { z } from 'zod'

export const datatableSearchSchema = z.object({
  page: z.coerce.number().optional(),
  pageSize: z.coerce.number().optional(),
  sort: columnSort.optional(),
  locale: z.string().optional(),
})
